export default __webpack_public_path__ + "static/media/d1.d390254d.png";